import { supabase } from "@/integrations/supabase/client";

export interface SocialAccount {
  id: string;
  platform: string;
  handle: string;
  profile_url: string;
  display_name: string | null;
  avatar_url: string | null;
  bio: string | null;
  is_active: boolean;
  auto_publish: boolean;
  sync_frequency: number;
  last_synced_at: string | null;
  last_error: string | null;
  posts_count: number;
}

export interface SocialPost {
  id: string;
  account_id: string;
  post_url: string;
  caption: string | null;
  thumbnail_url: string | null;
  media_url: string | null;
  media_type: string;
  posted_at: string | null;
  article_id: string | null;
  is_hidden: boolean;
}

export const getSocialAccounts = async (includeInactive = false): Promise<SocialAccount[]> => {
  let query = supabase.from("social_accounts").select("*").order("created_at", { ascending: true });
  if (!includeInactive) query = query.eq("is_active", true);
  const { data, error } = await query;
  if (error) throw error;
  return (data ?? []) as SocialAccount[];
};

export const getSocialPosts = async (accountId?: string, limit = 60): Promise<SocialPost[]> => {
  let query = supabase
    .from("social_posts")
    .select("*")
    .order("posted_at", { ascending: false, nullsFirst: false })
    .limit(limit);
  if (accountId) query = query.eq("account_id", accountId);
  const { data, error } = await query;
  if (error) throw error;
  return (data ?? []) as SocialPost[];
};
